import {useState} from 'react';
import axios from 'axios';
import Notification from '../shared/Notification';

const EmailPage = () => {
    const [receiverId, setReceiverId] = useState('');
    const [receiverName, setReceiverName] = useState('');
    const [notification, setNotification] = useState(null);
    


    const sendTestEmail = async () => {
        try {
            const response = await axios.post('/api/authApplicant/form-signup-691', {
                emailOrPhone: receiverId,
                name: receiverName
            });
            // console.log('Email sent:', response.data);
            setNotification(response.data.message || 'Email sent successfully!');
            // if(response.data.success){
            //     setNotification(response.data.message || 'Email sent successfully!');  
            // }
        } catch (error) {
            //  console.error('Error sending email:', error.message);

    // setNotification(
    //     error.response?.data?.message || 
    //     error.message || 
    //     "Something went wrong"
    // );
        }
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <div>
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <h1>Email Page</h1>
            <p>This is a placeholder for the email page.</p>
            nitish3542@gmail.com
            Nitish Shankar
            To:<input type="text" value={receiverId} onChange={(e) => setReceiverId(e.target.value)} />
            Name:<input type="text" value={receiverName} onChange={(e) => setReceiverName(e.target.value)} />
            <button onClick={sendTestEmail}>Send Email</button>
            <button onClick={() => window.location.href = '/admin'}>Back to Admin Dashboard</button>
        </div>
    );
}

export default EmailPage;